import { render, staticRenderFns } from "./EPGProviders.vue?vue&type=template&id=2f53bf0d&"
import script from "./EPGProviders.vue?vue&type=script&lang=js&"
export * from "./EPGProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports